import { formatString } from '../../../assets/js/utils/formatString';

function getHeadingsMapping(stepType, resourceTexts, productData) {
    const productTitle = productData ? productData.name : '';

    switch (stepType) {
        case 'StandAloneLogin':
            return {
                title: resourceTexts.standAloneLoginTitle,
                mainHeading: null,
            };
        case 'StandAloneSelectOrganization':
            return {
                title: resourceTexts.standAloneLoginSelectOrganizationTitle,
                mainHeading: null,
            };
        case 'CalculationLogin':
            return {
                title: resourceTexts.calculationLoginTitle,
                mainHeading: formatString(resourceTexts.calculationLoginMainHeading, [
                    productTitle,
                ]),
            };
        case 'CalculationSelectOrganization':
        case 'CalculationNoOrganizationAvailable':
            return {
                title: formatString(resourceTexts.calculationSelectOrganizationTitle, [
                    productTitle,
                ]),
                mainHeading: resourceTexts.calculationSelectOrganizationMainHeading,
            };
        default:
            return {};
    }
}

export { getHeadingsMapping };
